import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { useStatsig } from '../hooks/useStatsig';
import * as popupActions from '../../actions/popup-actions';
import ActivateUtrUnderAgePopUp from '../PopUps/ActivateUtrUnderAgePopUp';
import SuccessPopupV2 from '../Upgrade/UpgradeToPowerPopupV2/SuccessPopupV2';
import { PopupTypes } from '../../utils/constants';
import UpgradeToPowerPopupV2 from '../Upgrade/UpgradeToPowerPopupV2';
import UpgradeToPowerPopupV3 from '../Upgrade/UpgradeToPowerPopupV3';
import UpgradeToPowerPopupV4 from '../Upgrade/UpgradeToPowerPopupV4';
import UpgradePowerMonthlyToAnnualPopup from '../Upgrade/UpgradePowerMonthlyToAnnualPopup';
import MonthlyToAnnualSuccessPopup from '../Upgrade/UpgradePowerMonthlyToAnnualPopup/MonthlyToAnnualSuccessPopup';
import NotReadyForPowerPopup from '../GlobalPrivileges/NotReadyForPowerPopup';
import ResumePowerConfirmPopUp from '../Upgrade/ResumePowerConfirmPopUp';

const PopupContainer = () => {
    const popups = useSelector(({ popups }) => popups);
    const dispatch = useDispatch();
    const { checkGate, featureGates } = useStatsig();
    const {
        activateUtrUnderAge,
        gatedFeature,
        hotelPlannerUpgrade,
        notReadyForPower,
        powerMonthlyUpgrade,
        powerMonthlyUpgradeSuccess,
        powerResumeConfirm,
        powerSuccessV2,
        powerUpgrade,
        notReadyForPowerRedirectTo,
        referringSurface,
        renewalDate,
        prismicTitle,
    } = popups || {};

    // Check if new V4 popup feature gate is enabled
    const useV4Popup = checkGate(featureGates.POWER_UPGRADE_MODAL_V4);
    // Check if country pricing feature gate is enabled (true = V3, false = V2) for old flow
    const useCountryPricing = checkGate(featureGates.COUNTRY_PRICING);

    const renderPowerUpgradePopup = () => {
        // If V4 feature gate is enabled, use new popup with hotel planner card
        if (useV4Popup) {
            return (
                <UpgradeToPowerPopupV4
                    onCloseClick={onCloseClick(PopupTypes.POWER_UPGRADE_POPUP)}
                    showHotelPlannerCard
                    gatedFeature={gatedFeature}
                    referringSurface={referringSurface}
                    prismicTitle={prismicTitle}
                />
            );
        }

        // Otherwise use old V2/V3 popup based on country pricing gate
        if (useCountryPricing) {
            return (
                <UpgradeToPowerPopupV3
                    gatedFeature={gatedFeature}
                    referringSurface={referringSurface}
                    onCloseClick={onCloseClick(PopupTypes.POWER_UPGRADE_POPUP)}
                    prismicTitle={prismicTitle}
                />
            );
        }

        return (
            <UpgradeToPowerPopupV2
                onCloseClick={onCloseClick(PopupTypes.POWER_UPGRADE_POPUP)}
            />
        );
    };

    const onCloseClick = (popUpType) => {
        const onClosePopupFunction = popups[`${popUpType}OnClosePopup`];

        return function onClick() {
            if (onClosePopupFunction) {
                onClosePopupFunction();
            }
            dispatch(popupActions.closePopup(popUpType));
        };
    };

    return (
        <div>
            {activateUtrUnderAge && (
                <ActivateUtrUnderAgePopUp
                    onCloseClick={onCloseClick(PopupTypes.ACTIVATE_UTR_UNDER_AGE_POPUP)}
                />
            )}
            {powerUpgrade && renderPowerUpgradePopup()}
            {powerSuccessV2 && (
                <SuccessPopupV2
                    onCloseClick={onCloseClick(PopupTypes.POWER_SUCCESS_POPUP_V2)}
                />
            )}
            {powerMonthlyUpgradeSuccess && (
                <MonthlyToAnnualSuccessPopup
                    onCloseClick={onCloseClick(PopupTypes.POWER_MONTHLY_UPGRADE_SUCCESS_POPUP)}
                    renewalDate={renewalDate}
                />
            )}
            {hotelPlannerUpgrade && useV4Popup && (
                <UpgradeToPowerPopupV4
                    onCloseClick={onCloseClick(PopupTypes.UPGRADE_TO_POWER_POPUP)}
                    showHotelPlannerCard={false}
                    referringSurface={referringSurface}
                    gatedFeature={gatedFeature}
                    prismicTitle={prismicTitle}
                />
            )}
            {powerMonthlyUpgrade && (
                <UpgradePowerMonthlyToAnnualPopup
                    onCloseClick={onCloseClick(PopupTypes.POWER_MONTHLY_UPGRADE_POPUP)}
                    referringSurface={referringSurface}
                    gatedFeature={gatedFeature}
                    prismicTitle={prismicTitle}
                />
            )}
            {notReadyForPower && (
                <NotReadyForPowerPopup
                    onCloseClick={onCloseClick(PopupTypes.NOT_READY_FOR_POWER_POPUP)}
                    redirectUrl={notReadyForPowerRedirectTo}
                />
            )}
            {powerResumeConfirm && (
                <ResumePowerConfirmPopUp
                    onCloseClick={onCloseClick(PopupTypes.POWER_RESUME_CONFIRM_POPUP)}
                />
            )}
        </div>
    );
};

export default withRouter(PopupContainer);
